import ByteProService from "../services/bytepro.service";
// import moment from 'moment';

export const bytepro = {
  namespaced: true,
  state: {
    pipeline: null,
    loanDetail: null,
    lastUpdatedTime: null,
  },
  getters: {
    isReadyPipeline: (state) => {
      if (!state.pipeline || state.pipeline.length === 0) return false;
      else return true;
    },
    // getPipelineData: state => {
    //   return state.pipeline;
    // }
  },
  actions: {
    // detail level: Basic, AdvancedSet, AllWithOutEmbeddedDocs, All
    // getLoanNumberTable({ commit }) {
    //   return ByteProService.getFileData(loanNumber, detailLevel).then(
    //      fileData => {
    //        commit('dummyConsole', "getFileData - success");
    //        return Promise.resolve(fileData);
    //      },
    //      error => {
    //          commit('dummyConsole', "getFileData - failure");
    //          return Promise.reject(error.response);
    //      }
    //  );
    // },

    getFileData({ commit }, { loanNumber, detailLevel }) {
      return ByteProService.getFileData(loanNumber, detailLevel).then(
        (fileData) => {
          commit("dummyConsole", "getFileData - success");
          return Promise.resolve(fileData);
        },
        (error) => {
          commit("dummyConsole", "getFileData - failure");
          return Promise.reject(error.response);
        }
      );
    },

    getPipelineByDateRange({ commit }, fileDataSearchOption) {
      return ByteProService.getPipelineByDateRange(fileDataSearchOption).then(
        (pipeline) => {
          commit("dummyConsole", "getPipelineByDateRange - success");
          return Promise.resolve(pipeline);
        },
        (error) => {
          commit("dummyConsole", "getPipelineByDateRange - failure");
          return Promise.reject(error);
        }
      );
    },

    getSubmissionPipeline() {
      return ByteProService.getSubmissionPipeline().then(
        (pipeline) => {
          return Promise.resolve(pipeline);
        },
        (error) => {
          return Promise.reject(error.response);
        }
      );
    },

    getOrganizations() {
      return ByteProService.getOrganizations().then(
        (orgs) => {
          return Promise.resolve(orgs);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
    getPrintSets({ commit }) {
      return ByteProService.getPrintSets().then(
        (data) => {
          commit("dummyConsole", "getPrintSets - success");
          return Promise.resolve(data);
        },
        (error) => {
          commit("dummyConsole", "getPrintSets - error");
          return Promise.reject(error.response);
        }
      );
    },
    getPrintSetItems({ commit }) {
      return ByteProService.getPrintSetItems().then(
        (data) => {
          commit("dummyConsole", "getPrintSets - success");
          return Promise.resolve(data);
        },
        (error) => {
          commit("dummyConsole", "getPrintSets - error");
          return Promise.reject(error.response);
        }
      );
    },

    getDocumentProperties({ commit }, loanNumber) {
      return ByteProService.getDocumentProperties(loanNumber).then(
        (data) => {
          commit("dummyConsole", "getDocumentProperties - success");
          return Promise.resolve(data);
        },
        (error) => {
          commit("dummyConsole", "getDocumentProperties - success");
          return Promise.reject(error.response);
        }
      );
    },

    getEmbeddedDocs({ commit }, loanNumber) {
      return ByteProService.getEmbeddedDocs(loanNumber).then(
        (data) => {
          commit("dummyConsole", "getEmbeddedDocs - success");
          return Promise.resolve(data);
        },
        (error) => {
          commit("dummyConsole", "getEmbeddedDocs - error");
          return Promise.reject(error.response);
        }
      );
    },

    getDocSigners({ commit }, loanNumber) {
      return ByteProService.getDocSigners(loanNumber).then(
        (data) => {
          commit("dummyConsole", "getDocSigners - success");
          return Promise.resolve(data);
        },
        (error) => {
          commit("dummyConsole", "getDocSigners - error");
          return Promise.reject(error.response);
        }
      );
    },

    getDocPackages({ commit }, loanNumber) {
      return ByteProService.getDocPackages(loanNumber).then(
        (data) => {
          commit("dummyConsole", "getDocPackages - success");
          return Promise.resolve(data);
        },
        (error) => {
          commit("dummyConsole", "getDocPackages - error");
          return Promise.reject(error.response);
        }
      );
    },

    getDocPackagesDocuSign({ commit }) {
      return ByteProService.getDocPackagesDocuSign().then(
        (data) => {
          commit("dummyConsole", "getDocPackagesDocuSign - success");
          return Promise.resolve(data);
        },
        (error) => {
          commit("dummyConsole", "getDocPackagesDocuSign - error");
          return Promise.reject(error.response);
        }
      );
    },

    getDisclosureLogEntries({ commit }, loanNumber) {
      return ByteProService.getDisclosureLogEntries(loanNumber).then(
        (data) => {
          commit("dummyConsole", "getDisclosureLogEntries - success");
          return Promise.resolve(data);
        },
        (error) => {
          commit("dummyConsole", "getDisclosureLogEntries - error");
          return Promise.reject(error.response);
        }
      );
    },
  },
  mutations: {
    setLoanDetail(state, fileData) {
      state.loanDetail = fileData;
    },
    // setAccessableLoanNumberList(state, loanNumberList){
    //   state.accessableLoanNumberList = loanNumberList;
    // },
    dummyConsole(state, obj) {
      console.log(obj);
    },
  },
};
